import { PartnerConfiguration } from '@percent/education-hosted-form/api/partnerConfig/partnerConfig.types'

export enum FormState {
  INITIAL = 'INITIAL',
  DIRTY = 'DIRTY',
  SUBMITTED = 'SUBMITTED',
  ERROR = 'ERROR'
}

export type EducationHostedFormContextType = {
  isLoading: boolean
  formState: FormState
  setFormState: (state: FormState) => void
  progress: number
  partnerConfig?: PartnerConfiguration
  otpCooldownEndsAt: number | null
  setOtpCooldown: (seconds: number) => void
  clearOtpCooldown: () => void
  mustReverifyOtp: boolean
  setMustReverifyOtp: (value: boolean) => void
  mustReverifyCaptcha: boolean
  setMustReverifyCaptcha: (value: boolean) => void
  agentVerificationId?: string
  setAgentVerificationId: (id?: string) => void
}

export interface SelectOption {
  label: string
  value: string
  description?: string
}
